import React from "react";

import { ReactComponent as RupeeSvg } from "../../assets/ic-type-cod-rupee.svg";

const IconBase = ({ children, className = "", size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
    className={className}>
    {children}
  </svg>
);

export const IconHandling = props => (
  <IconBase {...props}>
    <path
      d="M4 2h8l1 3v8a1 1 0 01-1 1H4a1 1 0 01-1-1V5l1-3z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
    <path
      d="M3 5h10M6 8h4"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
  </IconBase>
);

export const IconService = props => (
  <IconBase {...props}>
    <path
      d="M5 4.5l6 6M9.5 4.5l-4 4"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
    <circle cx="4" cy="4" r="2" stroke="currentColor" strokeWidth="1.3" />
    <circle cx="12" cy="12" r="2" stroke="currentColor" strokeWidth="1.3" />
  </IconBase>
);

export const IconInstallation = ({ size = 18, ...props }) => (
  <IconBase size={size} {...props}>
    <path
      d="M8 2v4M5 6h6M4 14h8M6 10h4v4H6v-4z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M3 14h10" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
  </IconBase>
);

export const IconTechnician = ({ size = 18, ...props }) => (
  <IconBase size={size} {...props}>
    <circle cx="8" cy="5" r="2.2" stroke="currentColor" strokeWidth="1.2" />
    <path
      d="M3 14c.8-2.5 2.5-3.8 5-3.8s4.2 1.3 5 3.8"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
    <path d="M11 7l2 2" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
  </IconBase>
);

export const IconInfo = props => (
  <IconBase {...props}>
    <circle cx="8" cy="8" r="5.5" stroke="currentColor" strokeWidth="1.3" />
    <path
      d="M8 7v4M8 5.5v.5"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
  </IconBase>
);

export const IconFolder = props => (
  <IconBase {...props}>
    <path
      d="M2 4.5h4l1.5 1.5H14v6.5a1 1 0 01-1 1H3a1 1 0 01-1-1V4.5z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
  </IconBase>
);

export const IconTracking = props => (
  <IconBase {...props}>
    <path
      d="M8 1.5C5.5 1.5 3.5 3.5 3.5 6c0 3.5 4.5 8.5 4.5 8.5S12.5 9.5 12.5 6c0-2.5-2-4.5-4.5-4.5z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
    <circle cx="8" cy="6" r="1.5" stroke="currentColor" strokeWidth="1.3" />
  </IconBase>
);

export const IconFiles = props => (
  <IconBase {...props}>
    <path
      d="M4 2h5l3 3v8a1 1 0 01-1 1H4a1 1 0 01-1-1V3a1 1 0 011-1z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
    <path d="M9 2v3h3" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
  </IconBase>
);

export const IconHistory = props => (
  <IconBase {...props}>
    <path
      d="M2.6 8a5.4 5.4 0 105.4-5.4A5.4 5.4 0 003.5 5"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
    <path
      d="M2.4 2.6V5h2.4"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 5.4V8l1.9 1.2"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </IconBase>
);

export const IconUser = ({ size = 14, ...props }) => (
  <IconBase size={size} {...props}>
    <circle cx="8" cy="5.5" r="2.3" stroke="currentColor" strokeWidth="1.3" />
    <path
      d="M3.4 13.2c.8-2.3 2.4-3.5 4.6-3.5s3.8 1.2 4.6 3.5"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
  </IconBase>
);

export const IconComments = props => (
  <IconBase {...props}>
    <path
      d="M3 3h10a1 1 0 011 1v6a1 1 0 01-1 1H6l-3 2V4a1 1 0 011-1z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
  </IconBase>
);

export const IconTag = ({ size = 14, ...props }) => (
  <IconBase size={size} {...props}>
    <path
      d="M2 8l6-6h3l3 3v3L8 14 2 8z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
    <circle cx="9" cy="5" r="1" fill="currentColor" />
  </IconBase>
);

export const IconBox = ({ size = 14, ...props }) => (
  <IconBase size={size} {...props}>
    <path
      d="M2 5l6-3 6 3v6l-6 3-6-3V5z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
    <path d="M8 2v12M2 5l6 3 6-3" stroke="currentColor" strokeWidth="1.2" />
  </IconBase>
);

export const IconHash = ({ size = 14, ...props }) => (
  <IconBase size={size} {...props}>
    <path
      d="M5 3l1 10M10 3l1 10M3 6h10M2.5 11h10"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
  </IconBase>
);

export const IconLayers = ({ size = 14, ...props }) => (
  <IconBase size={size} {...props}>
    <path
      d="M2 5l6-3 6 3-6 3-6-3zM2 9l6 3 6-3"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
  </IconBase>
);

export const IconFragile = ({ size = 14, ...props }) => (
  <IconBase size={size} {...props}>
    <rect x="3" y="3" width="10" height="10" rx="1" stroke="currentColor" strokeWidth="1.2" />
    <path d="M3 8h10M8 3v10" stroke="currentColor" strokeWidth="1.2" />
  </IconBase>
);

export const IconHandshake = ({ size = 14, ...props }) => (
  <IconBase size={size} {...props}>
    <path
      d="M2 9l2-2 2 2 3-3 3 3 2-2"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </IconBase>
);

export const IconWhatsApp = ({ size = 14, className = "", ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    className={className}
    {...props}>
    <path
      d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.435 9.884-9.881 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"
      fill="currentColor"
    />
  </svg>
);

export const IconChannel = ({ size = 14, ...props }) => (
  <IconBase size={size} {...props}>
    <circle cx="4" cy="8" r="1.5" stroke="currentColor" strokeWidth="1.2" />
    <circle cx="12" cy="4" r="1.5" stroke="currentColor" strokeWidth="1.2" />
    <circle cx="12" cy="12" r="1.5" stroke="currentColor" strokeWidth="1.2" />
    <path d="M5.5 7.5l4-2.5M5.5 8.5l4 2.5" stroke="currentColor" strokeWidth="1.2" />
  </IconBase>
);

export const IconPayment = ({ size = 14, ...props }) => (
  <IconBase size={size} {...props}>
    <rect x="2" y="4" width="12" height="8" rx="1" stroke="currentColor" strokeWidth="1.2" />
    <path d="M2 7h12" stroke="currentColor" strokeWidth="1.2" />
  </IconBase>
);

export const IconRupee = ({ size = 14, className = "", ...props }) => (
  <RupeeSvg
    width={size}
    height={size}
    className={`fill-current ${className}`}
    aria-hidden="true"
    {...props}
  />
);

export const IconWallet = ({ size = 14, ...props }) => (
  <IconBase size={size} {...props}>
    <path
      d="M2 5h10a1 1 0 011 1v5a1 1 0 01-1 1H2V5z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
    <circle cx="11" cy="8.5" r="1" fill="currentColor" />
  </IconBase>
);

export const IconDocument = ({ size = 14, ...props }) => (
  <IconBase size={size} {...props}>
    <rect x="3" y="2" width="10" height="12" rx="1" stroke="currentColor" strokeWidth="1.2" />
    <path d="M6 6h4M6 9h4" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
  </IconBase>
);

export const IconCopy = ({ size = 14, ...props }) => (
  <IconBase size={size} {...props}>
    <rect x="5.5" y="5.5" width="8" height="8" rx="1" stroke="currentColor" strokeWidth="1.2" />
    <path
      d="M10.5 3.5v-.5a1 1 0 00-1-1h-6a1 1 0 00-1 1v6a1 1 0 001 1h.5"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
  </IconBase>
);

export const IconBoxNo = ({ size = 14, ...props }) => (
  <IconBase size={size} {...props}>
    <rect x="3" y="3" width="10" height="10" rx="1" stroke="currentColor" strokeWidth="1.2" />
    <path d="M6 8h4" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
  </IconBase>
);

export const IconDimensions = ({ size = 14, ...props }) => (
  <IconBase size={size} {...props}>
    <rect x="3" y="5" width="10" height="7" rx="1" stroke="currentColor" strokeWidth="1.2" />
    <path d="M3 8h10M8 5v7" stroke="currentColor" strokeWidth="1.2" />
  </IconBase>
);

export const IconWeight = ({ size = 14, ...props }) => (
  <IconBase size={size} {...props}>
    <path
      d="M3 11h10M5 11V7a3 3 0 016 0v4"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M8 4v1" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
  </IconBase>
);

export const IconTruck = ({ size = 18, ...props }) => (
  <IconBase size={size} {...props}>
    <rect x="1" y="4" width="8" height="6" rx="1" stroke="currentColor" strokeWidth="1.3" />
    <path d="M9 6h3l2 2v2H9" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
    <circle cx="4.5" cy="11.5" r="1.3" stroke="currentColor" strokeWidth="1.3" />
    <circle cx="11.5" cy="11.5" r="1.3" stroke="currentColor" strokeWidth="1.3" />
  </IconBase>
);

export const IconChevronDown = ({ size = 16, className = "", ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <path
      d="M3.5 6L8 10.5 12.5 6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </IconBase>
);

export const IconCalendar = ({ size = 18, ...props }) => (
  <IconBase size={size} {...props}>
    <rect x="2" y="3" width="12" height="11" rx="1.2" stroke="currentColor" strokeWidth="1.3" />
    <path d="M2 7h12M5.5 2v2.5M10.5 2v2.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
  </IconBase>
);

export const IconCalendarRange = ({ size = 18, ...props }) => (
  <IconBase size={size} {...props}>
    <rect x="2" y="3" width="12" height="11" rx="1.2" stroke="currentColor" strokeWidth="1.3" />
    <path d="M2 7h12M5.5 2v2.5M10.5 2v2.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    <rect x="4.4" y="8.8" width="2.4" height="2.4" rx="0.4" fill="currentColor" />
    <rect x="9.2" y="8.8" width="2.4" height="2.4" rx="0.4" fill="currentColor" opacity="0.4" />
  </IconBase>
);

export const IconCheckCircle = ({ size = 18, ...props }) => (
  <IconBase size={size} {...props}>
    <circle cx="8" cy="8" r="5.5" stroke="currentColor" strokeWidth="1.3" />
    <path
      d="M5.5 8l1.8 1.8L10.5 6.5"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </IconBase>
);

export const IconWarehouse = ({ size = 18, ...props }) => (
  <IconBase size={size} {...props}>
    <path
      d="M2 7.5L8 3l6 4.5V13H2V7.5z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
    <path d="M6.5 13V9h3v4" stroke="currentColor" strokeWidth="1.3" />
  </IconBase>
);

export const IconXCircle = ({ size = 18, ...props }) => (
  <IconBase size={size} {...props}>
    <circle cx="8" cy="8" r="5.5" stroke="currentColor" strokeWidth="1.3" />
    <path
      d="M6 6l4 4M10 6l-4 4"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
  </IconBase>
);

export const IconLock = ({ size = 12, ...props }) => (
  <IconBase size={size} {...props}>
    <rect x="3" y="7" width="10" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.3" />
    <path d="M5 7V5a3 3 0 016 0v2" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
  </IconBase>
);
